import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {addStyle} from "@khanacademy/wonder-blocks-core";
import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";

const StyledHr = addStyle("hr");

export default function HorizontalRuleNode(
    props: RenderElementProps,
): React.ReactElement {
    const {attributes, children} = props;

    return (
        <div>
            <StyledHr
                {...attributes}
                style={styles.hr}
                contentEditable={false}
            />
            {children}
        </div>
    );
}

const styles = StyleSheet.create({
    hr: {
        borderBlockStart: `1px solid ${semanticColor.core.border.neutral.subtle}`,
        outline: 0,
        paddingBlockStart: 0,
        marginBlockEnd: spacing.medium_16,
        marginBlockStart: spacing.large_24,
    },
});
